export const headerHeight = 88;
export const horizentalMenuHeight = 30;
export const siderExpandedWidth = 240;
export const sidercollapsedWidth = 72;
